module.exports = __webpack_public_path__ + "images/sixt9b0095dedd56ddd261bb97437e8a68b8.png";